import type { PartnerInjectionSite } from '@shipium-corp/shipium-ts-types';
import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';
import type { LinkAssetPayload, BulkLinkPayloads } from '../api-utils';
import { linkMultipleAssets } from '../api-utils';

type SingleAssetLinkType = '';
type ArrayAssetLinkType = 'tags';

export const injectionSites = {
  search: {
    queryKey: 'partner-management-service/injection-sites',
    configurationType: 'default' as const,
    fn: async () => {
      const { data } = await GatewayAxiosClient.get<PartnerInjectionSite[]>(
        `/partner-management-proxy/api/v1/partners/injectionSite`,
      );

      return data;
    },
  },
  link: async ({
    injectionProfileId,
    payload,
  }: {
    injectionProfileId: string;
    payload: LinkAssetPayload<SingleAssetLinkType | ArrayAssetLinkType>;
  }) => {
    await GatewayAxiosClient({
      method: payload.linkAction === 'link' ? 'PUT' : 'DELETE',
      url:
        `/partner-management-proxy/api/v1/partners/injectionSite` +
        `/${injectionProfileId}/${payload.assetType}/${payload.assetId}`,
    });

    return {
      invalidateQueryKeys: [
        ['partner-management-service/injection-sites'],
        ['partner-management-service/injection-sites/id', injectionProfileId],
      ],
    };
  },
  bulkLink: async ({
    injectionProfile,
    payloads,
  }: {
    injectionProfile: PartnerInjectionSite;
    payloads: BulkLinkPayloads<SingleAssetLinkType, ArrayAssetLinkType>;
  }) => {
    return await linkMultipleAssets<SingleAssetLinkType, ArrayAssetLinkType, PartnerInjectionSite>(
      payloads,
      {
        tags: injectionProfile.tagIds,
      },
      (payload) => injectionSites.link({ injectionProfileId: injectionProfile.injectionSiteId, payload }),
    );
  },
};
